import { MainService } from 'src/app/Services/service.service';
import {Component, OnInit, Optional, Inject, HostListener, ViewEncapsulation} from "@angular/core";
import {FormBuilder, Validators, FormGroup, FormControl} from "@angular/forms";

import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material";

@Component({
  selector: "app-login",
  templateUrl: "./dialog.login.component.html",
  styleUrls: ["./dialog.login.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class DialogLoginComponent implements OnInit {
  loginForm = this.fb.group({
    email: [null, Validators.required],
    password: [null, Validators.required],
    rememberme: [true]
  });

  public additionalLoginTitle: string | undefined = undefined;

  private _showPassword: boolean = false;
  get showPassword(): boolean {
    return this._showPassword;
  }

  set showPassword(value: boolean) {
    this._showPassword = value;
  }



  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<DialogLoginComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any, public service: MainService) {

    if(this.dialogRef){
    this.dialogRef.addPanelClass("login-dialog-backdrop");
    }
    if (this.data && this.data.email && this.data.email != 'undefined') {
      this.loginForm.controls["email"].setValue(this.data.email);
    }
    if (this.data && this.data.password) {
      this.loginForm.controls["password"].setValue(this.data.password);
    }

    if (this.data && this.data.rememberme) {
      this.loginForm.controls["rememberme"].setValue(this.data.rememberme);
    }
    if (this.data && this.data.additionalLoginTitle) {
      this.additionalLoginTitle = this.data.additionalLoginTitle;
    }


  }

  ngOnInit() {
  }

  private _captchaResolvedFlag = false;

  getCaptchaResolvedFlag(): boolean {
    return this._captchaResolvedFlag;
  }

  setCaptchaResolvedFlag(value) {
    this._captchaResolvedFlag = value;
  }

  captchaResolved(captchaResponse: string) {
    this.setCaptchaResolvedFlag(true)
  }

  captchaAvailable() {
    return this.service.captchaService.getCurrentCaptchaKey() != "";
  }

  isCaptchaOk(): boolean {
    return true;
    return this.captchaAvailable() && this._captchaResolvedFlag;
  }

  closeAction() {
    this.dialogRef.close();
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  onSubmit() {
    this.validateAllFormFields(this.loginForm)
    if (!this.loginForm.invalid) {
      if (!this.isCaptchaOk()) {
        this.service.showError("Please confirm the captcha");
      }else{
        this.dialogRef.close({
          email: this.loginForm.controls["email"].value,
          password: this.loginForm.controls["password"].value,
          rememberme: this.loginForm.controls["rememberme"].value
        });
      }
    }
  }

  @HostListener('window:keyup', ['$event'])
  keyEventUp(event: KeyboardEvent) {

    if (event.keyCode === 13) {
      this.onSubmit();
    }
  }

}
